/**
 * Global Imports
*/

import { Client, ChatUserstate } from 'tmi.js';

/**
 * Local Imports
*/

import { ChatDispatch } from '@system/Chat';
import { CommandDispatch } from '@system/Command';
import { Endpoint } from '@system/Network';
import { UserCreate } from '@system/User';

/**
 * Locals
*/

let client: Client;
let connection: Endpoint;
let isPreviousMessageBot: boolean;
let isPreviousMessageCommand: boolean;
let isPreviousMessageCommandResponse: boolean;

/**
 * Private Functions
*/

/**
 * @param {string} channel
 * @param {ChatUserstate} state
 * @param {string} contents
 * @param {boolean} self
 *
 * @return {void}
 */
function handlePayload(
  channel: string,
  state: ChatUserstate,
  contents: string,
  self: boolean): void
{
  const user = UserCreate(state);

  isPreviousMessageBot = self;
  isPreviousMessageCommandResponse = self && isPreviousMessageCommand;
  isPreviousMessageCommand = !self && !!contents && contents[0] === '!' && contents.length > 1;

  if (!isPreviousMessageCommand) {
    return ChatDispatch(channel, user, contents);
  }

  const pivot = contents.indexOf(' ');
  const command = contents.slice(1, (pivot === -1) ? undefined : pivot);
  const args = (pivot === -1) ? undefined : contents.slice(pivot + 1);

  CommandDispatch(channel, user, command, args);
}

/**
 * Public Functions
*/

/**
 * @param {string} contents
 *
 * @return {void}
 */
export function TwitchWriteMessage(
  channel: string,
  contents: string): void
{
  client.say(channel, contents);
}

/**
 * @param {string} username
 * @param {string} password
 * @param {string | Array<string>} channel
 *
 * @return {Promise<Endpoint>}
 */
export function TwitchStart(
  username: string,
  password: string,
  channel: string | Array<string>): Promise<Endpoint>
{
  return new Promise((resolve, reject): void => {
    try {
      client = new Client({
        options: {
          debug: process.env.APP_DEBUG === 'true',
        },
        identity: { username, password },
        channels: Array.isArray(channel) ? channel : [ channel ],
      });
    } catch (error) {
      return reject(error);
    }

    client.on('message', handlePayload);
    client.on('connected', (address: string, port: number): void => {
      connection = { address, port };
      resolve(connection);
    });

    client.connect();
  });
}

/**
 * @return {boolean}
 */
export function TwitchPreviousMessageWasBot(): boolean
{
  return isPreviousMessageBot;
}

/**
 * @return {boolean}
 */
export function TwitchPreviousMessageWasCommandResponse(): boolean
{
  return isPreviousMessageCommandResponse;
}
